


























































































import Vue from 'vue';
import { formatCpf, formatDateString, formatSideWhitespaces } from '@/helpers/formatters';
import { isCpfValid, isDateStringValid } from '@/helpers/validators';
import { AutoCompleteInput, OutlinedTextInput, OutlinedSelect } from '@descomplica/vue-components';
import {
  AutocompleteOption,
  parseToAutocompleteOption,
  parseToAutocompleteOptionArray,
} from '@/helpers/autocomplete';

export interface PersonalDataFormEvent {
  cpf: string;
  race: string;
  gender: string;
  birthDate: string;
  nationality: string;
  placeOfBirth: string;
  householdIncome: string;
  partnerCode: string;
  cityBirth: string;
}

const NATIONALITY_BR = 'BRASILEIRA';
const STATE_NOT_INFORMED = 'NÃO INFORMADO';

export default Vue.extend({
  components: { AutoCompleteInput, OutlinedTextInput, OutlinedSelect },
  props: {
    currentCpf: {
      type: String,
      default: '',
    },
    currentRace: {
      type: String,
      default: '',
    },
    currentGender: {
      type: String,
      default: '',
    },
    currentBirthDate: {
      type: String,
      default: '',
    },
    currentNationality: {
      type: String,
      default: '',
    },
    currentPlaceOfBirth: {
      type: String,
      default: '',
    },
    currentHouseholdIncome: {
      type: String,
      default: '',
    },
    currentPartnerCode: {
      type: String,
      default: '',
    },
    cpfError: {
      type: Boolean,
      default: false,
    },
    currentCityBirth: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        cpf: this.currentCpf,
        race: this.currentRace,
        gender: this.currentGender,
        birthDate: this.currentBirthDate,
        nationality: this.currentNationality,
        placeOfBirth: this.currentPlaceOfBirth,
        householdIncome: this.currentHouseholdIncome,
        partnerCode: this.currentPartnerCode,
        cityBirth: this.currentCityBirth,
      },
      masks: {
        cpf: formatCpf,
        date: formatDateString,
        partnerCode: formatSideWhitespaces,
      },
      errors: {
        cpf: false,
        date: false,
      },
      isForeigner: this.currentNationality !== NATIONALITY_BR,
      isCountryDisabled:
        this.currentPlaceOfBirth === STATE_NOT_INFORMED || !this.currentPlaceOfBirth,
      isDisabled: this.currentNationality !== NATIONALITY_BR,
    };
  },
  computed: {
    raceOptions(): string[] {
      return this.$store.getters.raceOptions || [];
    },
    genderOptions(): string[] {
      return this.$store.getters.genderOptions || [];
    },
    nationalityOptions(): AutocompleteOption[] {
      return parseToAutocompleteOptionArray(this.$store.getters.nationalityOptions) || [];
    },
    placeOfBirthOptions(): AutocompleteOption[] {
      return this.$store.getters.placeOfBirthOptions || [];
    },
    householdIncomeOptions(): string[] {
      return this.$store.getters.householdIncomeOptions || [];
    },
    selectedNationality(): AutocompleteOption {
      return parseToAutocompleteOption(this.form.nationality);
    },
    selectedPlaceOfBirth(): AutocompleteOption {
      return this.$store.getters.placeOfBirthOption(this.form.placeOfBirth);
    },
    selectedCounty(): AutocompleteOption {
      return this.$store.getters.countyAutocompleteOption(this.form.cityBirth);
    },
    countyOptions(): AutocompleteOption[] {
      return this.$store.getters.countysAutocompleteOptions(this.selectedPlaceOfBirth?.key);
    },
    loadingCountysOptions(): boolean {
      return this.$store.getters.loadingCountysOptions;
    },
    isCountyDisable(): boolean {
      return this.isCountryDisabled || this.loadingCountysOptions;
    },
  },
  created() {
    this.$store.dispatch('PULL_RACE_OPTIONS');
    this.$store.dispatch('PULL_GENDER_OPTIONS');
    this.$store.dispatch('PULL_NATIONALITY_OPTIONS');
    // this.$store.dispatch('PULL_PLACE_OF_BIRTH_OPTIONS');
    this.$store.dispatch('PULL_HOUSEHOLD_INCOME_OPTIONS');

    if (this.selectedPlaceOfBirth.key)
      this.$store.dispatch('PULL_COUNTYS_ARGS_OPTIONS', {
        uf: this.selectedPlaceOfBirth.key,
      });
    else this.$store.dispatch('PULL_COUNTYS_OPTIONS');
  },
  methods: {
    inputHandler() {
      this.errors.cpf = !!this.form.cpf && !isCpfValid(this.form.cpf);
      this.errors.date = !!this.form.birthDate && !isDateStringValid(this.form.birthDate);

      this.isDisabled = !!this.isForeigner;

      const hasErrors = this.errors.cpf || this.errors.date;

      this.$emit('input', { ...this.form }, hasErrors);
    },
    selectHandlerNationality(option: AutocompleteOption) {
      this.isForeigner = option.value !== NATIONALITY_BR;
      this.form.nationality = option.value;

      if (this.isForeigner) {
        this.form.placeOfBirth = STATE_NOT_INFORMED;
        this.isCountryDisabled = true;
        this.form.cityBirth = '000000';
      }

      this.inputHandler();
    },
    selectHandlerPlaceOfBirth(str: string) {
      const option = this.placeOfBirthOptions.find(o => o.value === str);
      this.form.placeOfBirth = option?.value || STATE_NOT_INFORMED;
      this.isCountryDisabled = str === STATE_NOT_INFORMED;
      this.form.cityBirth = this.isCountryDisabled ? '000000' : '';

      if (!this.isCountryDisabled) {
        this.$store.dispatch('PULL_COUNTYS_ARGS_OPTIONS', { uf: option?.key });
      }

      this.inputHandler();
    },
    selectHandlerCounty(option: AutocompleteOption) {
      if (this.isForeigner) {
        this.isCountryDisabled = true;
        return;
      }

      const countyData = this.$store.getters.countyData(option.key);
      this.form.cityBirth = countyData.id;
      this.inputHandler();
    },
  },
});
